<script lang="typescript">
  // types
  import type { Readable } from 'svelte/store';
  import type { RaceInterface } from '../interfaces';

  // props
  export let races: Readable<RaceInterface[]>;

  function getWinnerCounts(races: RaceInterface[]) {
    let gop = 0;
    let dem = 0;
    let other = 0;

    for (let i = 0; i < races.length; i++) {
      const race = races[i];

      for (let j = 0; j < race.candidates.length; j++) {
        const candidate = race.candidates[j];

        if (candidate.is_winner) {
          const party = candidate.party;

          if (party === 'gop') {
            gop += 1;
          } else if (party === 'dem') {
            dem += 1;
          } else {
            other += 1;
          }

          break;
        }
      }
    }

    return { gop, dem, other };
  }

  $: winners = getWinnerCounts($races);
</script>

{#if winners && winners.gop + winners.dem + winners.other > 0}
  Currently, Republicans have won
  {winners.gop}
  seats, and Democrats have won
  {winners.dem}
  seats.
{/if}
